"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCustomFocusIndicatorStyle", {
    enumerable: true,
    get: ()=>createCustomFocusIndicatorStyle
});
const _constants = require("./constants");
function createCustomFocusIndicatorStyle(style, { selector =_constants.defaultOptions.selector , enableOutline =false  } = _constants.defaultOptions) {
    return {
        ':focus': {
            outlineStyle: enableOutline ? undefined : 'none'
        },
        ':focus-visible': {
            outlineStyle: enableOutline ? undefined : 'none'
        },
        ...selector === 'focus' && {
            [`&[${_constants.FOCUS_VISIBLE_ATTR}]`]: style
        },
        ...selector === 'focus-within' && {
            [`&[${_constants.FOCUS_WITHIN_ATTR}]:${selector}`]: style
        }
    };
} //# sourceMappingURL=createCustomFocusIndicatorStyle.js.map

//# sourceMappingURL=createCustomFocusIndicatorStyle.js.map